import Konva from 'konva';
import * as _ from 'lodash';
import { HGroup } from '../area/HGroup';
import { SC_Input } from '../input/SC_Input';
import { MountingSystem } from '../mountsys/MountingSystem';
import { Sol50 } from '../mountsys/Sol50';
import { Global } from '../utilities/global';
import { GetArea } from './areaConvertion';
import { DrawRoofForPanel } from './drawRoofForPanel';
import { layoutCheckIntegrated } from "./layoutCheckIntegrated";
import { ModList } from './ModList';

export class EllipseError {
	static nGroupDistanceH: number = Sol50.nHorizontalAbstand + Global.nModAbstTol;
	static nGroupDistanceV: number = Sol50.nVertikalAbstand + Global.nModAbstTol;
	static nSnapVal: number = 30;
	//in cm
	static nGroupDistance: number = 20;
	static removeAllEllipse() {
		var obj: any = DrawRoofForPanel.layerPanel.find(".ellipseError");
		if (obj && obj.length > 0)
			obj.forEach((item: any) => {
				item.destroy();
			});
		DrawRoofForPanel.elipseGroup.removeChildren();
		DrawRoofForPanel.layerPanel.batchDraw();
	}
	static check_HGroups() {
		if (SC_Input.iMountSys == MountingSystem.SOL50_PREM_IN) {
			layoutCheckIntegrated.checkGroups();
		} else {
			this.check_HGroups_normal_mounting();
		}
	}

	static check_HGroups_normal_mounting() {
		EllipseError.removeAllEllipse();
		var hgroupTmp: HGroup;
		var i: number, j: number;
		var iLen: number;
		var bRet: boolean;

		iLen = Global.hgroups.length;
		for (let i = 0; i < iLen; i++) {
			const hGroupI = new HGroup(Global.hgroups[i]);
			const nTop1 = hGroupI.y;
			const nBottom1 = hGroupI.y + hGroupI.height;
			const nLeft1 = hGroupI.x;
			const nRight1 = hGroupI.x + hGroupI.width;
			for (let j = 0; j < iLen; j++) {
				if (i != j) {
					const hGroupJ = new HGroup(Global.hgroups[j]);
					// console.log(hGroupI, hGroupJ)
					const nTop2 = hGroupJ.y;
					const nLeft2 = hGroupJ.x;
					const nRight2 = hGroupJ.x + hGroupJ.width;
					const diffY = hGroupI.y > hGroupJ.y ? hGroupI.y - hGroupJ.y : hGroupJ.y - hGroupI.y;
					if (hGroupJ.height > diffY) {
						if (nTop2 < nBottom1) {
							if (nLeft2 > nLeft1) {
								const diff = nLeft2 - nRight1 > 0 ? nLeft2 - nRight1 : nRight1 - nLeft2;
								// if (diff > 1.7 && diff < this.nSnapVal) {
								if (diff < 1.7 && !(parseInt(hGroupI.y.toString()) == parseInt(hGroupJ.y.toString()))) {
									EllipseError.HGroup_check_HDistance(new HGroup(Global.hgroups[i]), j, iLen);
									// console.log(hGroupI, hGroupJ)
									// console.log(diff);
									// this.drawEllipse(nLeft2, nTop2 + hGroupJ.height / 2, 30, hGroupJ.height);
									return;
								}
							} else {

								const diff = nLeft1 - nRight2 > 0 ? nLeft1 - nRight2 : nRight2 - nLeft1;
								// if (diff > 1.7 && diff < this.nSnapVal) {
								if (diff < 1.7 && !(parseInt(hGroupI.y.toString()) == parseInt(hGroupJ.y.toString()))) {
									// console.log(diff);
									EllipseError.HGroup_check_HDistance(new HGroup(Global.hgroups[i]), j, iLen);
									// this.drawEllipse(nLeft2, nTop2 + hGroupJ.height / 2, 30, hGroupJ.height);
									// console.log(hGroupI, hGroupJ,diff)
									return;
								}
							}
						} else {
							break;
						}
					}

				}
			}
		}
		bRet = true;
		if (iLen == 0) return bRet;
		//Global.hgroups was sorted by y
		for (i = 0; i < iLen; i++) {
			j = i + 1;
			if (j < iLen) {
				// bRet = EllipseError.HGroup_check_HDistance(new HGroup(Global.hgroups[i]), j, iLen);
				if (!bRet) return false;
			}
		}

		const groupsV = this.getGroups();
		// console.log(groupsV);
		for (i = 0; i < groupsV.length; i++) {
			for (j = 0; j < groupsV.length; j++) {

				if (i != j && !groupsV[i].mixed && !groupsV[j].mixed) {
					// ellipse H disttance
					const top1 = groupsV[i].y < groupsV[j].y ? groupsV[i] : groupsV[j];
					const top2 = groupsV[i].y > groupsV[j].y ? groupsV[i] : groupsV[j];
					const diffY = Math.abs(top2.y - top1.y - top1.height);
					if ((diffY >= (Sol50.nVertikalAbstand + Global.nModAbstTol) && diffY < this.nGroupDistance)) {
						const left1 = groupsV[i].x < groupsV[j].x ? groupsV[i] : groupsV[j];
						const left2 = groupsV[i].x > groupsV[j].x ? groupsV[i] : groupsV[j];

						if (left2.x < (left1.x + left1.width)) {
							const y = left1.y > left2.y ? left1.y - diffY : left2.y;
							// console.log("H")
							this.drawEllipseH(left2.x, y, left2.nModWidth * DrawRoofForPanel.currentScale, diffY * 1.5);
							return;
						}
					}

					// ellipse V disttance
					const left1 = groupsV[i].x < groupsV[j].x ? groupsV[i] : groupsV[j];
					const left2 = groupsV[i].x > groupsV[j].x ? groupsV[i] : groupsV[j];
					const diffX = left2.x - left1.x - left1.width;

					// console.log(diffX)
					if ((diffX > 0 && diffX < 0.6) || (diffX < this.nGroupDistance && diffX > 1.6)) {
						const t1 = groupsV[i].y < groupsV[j].y ? groupsV[i] : groupsV[j];
						const t2 = groupsV[i].y > groupsV[j].y ? groupsV[i] : groupsV[j];

						if (t2.y < (t1.y + t1.height)) {
							const y = t2.y - t1.y - t1.width;
							// const y = t1.x > t2.x ? t1.x - diffX : t2.x;
							// console.log("V")
							this.drawEllipseV(left2.x - diffX / 2, t2.y + t2.nModHeight / 2, 30, t2.nModHeight);
							return;
						}
					}
					if (!bRet) return false;
				}
			}
		}
		let foundError = false;
		if (ModList.listOfGroups && ModList.listOfGroups.length > 0) {
			ModList.listOfGroups.forEach((group1: any) => {
				let group = [...group1];
				group = _.sortBy(group, 'x');
				if (!foundError) {
					let old = group[0];
					for (let i = 1; i < group.length; i++) {
						if (old.height != group[i].height || old.width != group[i].width) {
							let x, y, height;
							if (old.x < group[i].x) {
								x = group[i].x;
								y = group[i].y;
								height = group[i].height;
							} else {
								x = group[i].x;
								y = group[i].y;
								height = group[i].height;
							}
							this.drawEllipseV(x, y + DrawRoofForPanel.currentScale * height / 2, 20, height);
							foundError = true;
						}
						old = group[i];
					}
				}
			});
		}
		return bRet;
	}
	//check horizontal distances of HGroup
	static HGroup_check_HDistance(hgroupTmp1: HGroup, iStart: number, iLen: number): boolean {
		// console.log(hgroupTmp1, iStart, iLen)
		var nTop1: number, nBottom1: number;
		var nLeft1: number, nRight1: number;
		var nTop2: number, nBottom2: number;
		var nLeft2: number, nRight2: number;
		var hgroupTmp2: HGroup;
		nTop1 = hgroupTmp1.y;
		nBottom1 = hgroupTmp1.y + hgroupTmp1.height;
		nLeft1 = hgroupTmp1.x;
		nRight1 = hgroupTmp1.x + hgroupTmp1.width;
		for (; iStart < iLen; iStart++) {
			hgroupTmp2 = new HGroup(Global.hgroups[iStart]);
			nTop2 = hgroupTmp2.y;
			//				nBottom2 = hgroupTmp2.y + hgroupTmp2.height;
			nLeft2 = hgroupTmp2.x;
			nRight2 = hgroupTmp2.x + hgroupTmp2.width;
			// console.log(nTop2 < nBottom1, "(nTop2 < nBottom1)")
			const diffX = Math.abs(hgroupTmp1.x - hgroupTmp2.x); //  hgroupTmp1.x > hgroupTmp2.x ? hgroupTmp1.x - hgroupTmp2.x : hgroupTmp2.x - hgroupTmp1.x;
			if (!hgroupTmp1.mixed && !hgroupTmp2.mixed) {
				if (nTop2 < nBottom1) {
					//x distance check
					// console.log(nLeft2 > nLeft1,"(nLeft2 > nLeft1)")
					if (nLeft2 > nLeft1) {
						// console.log(nLeft2 - nRight1, "nLeft2 - nRight1")
						if (nLeft2 - nRight1 < EllipseError.nGroupDistanceH) {
							EllipseError.drawHighlightH(nRight1, nTop2 > nTop1 ? nTop2 : nTop1, nLeft2 - nRight1, hgroupTmp1.height);
							return false;
						}
					} else {
						// console.log(nLeft1 - nRight2, "nLeft1 - nRight2")
						if (nLeft1 - nRight2 < EllipseError.nGroupDistanceH) {

							EllipseError.drawHighlightH(nRight2, nTop2 > nTop1 ? nTop2 : nTop1, nLeft1 - nRight2, hgroupTmp1.height);
							return false;
						}
					}
				} else {
					break;
				}
			}
		}
		return true;
	}

	static drawHighlightH(_x: number, _y: number, _width: number, _height: number): void {
		// Global.pageDesign.canHiLi.graphics.lineStyle(2, 0xff0000);
		// Global.pageDesign.canHiLi.graphics.
		const w = _width * DrawRoofForPanel.currentScale;
		const h = _height * DrawRoofForPanel.currentScale;
		EllipseError.drawEllipse1(_x, _y, _width, h);
	}

	static drawHighlightV(_x: number, _y: number, _width: number, _height: number): void {
		// Global.pageDesign.canHiLi.graphics.lineStyle(2, 0xff0000);
		// Global.pageDesign.canHiLi.graphics
		const w = _width * DrawRoofForPanel.currentScale;
		const h = _height * DrawRoofForPanel.currentScale;
		// EllipseError.drawEllipse((_x + (w / 2)), (_y + (h / 2)) - w / 6, w, w / 3);
	}

	static drawHighlightV2(_x: number, _y: number, _width: number, _height: number): void {
		var nWidth: number;
		var nHeight: number;
		nWidth = (SC_Input.nModWidth / 10) * DrawRoofForPanel.currentScale;
		nHeight = nWidth / 2;
		// Global.pageDesign.canHiLi.graphics.lineStyle(2, 0xff0000);
		// Global.pageDesign.canHiLi.graphics
		// EllipseError.drawEllipse(_x - nWidth / 2, (_y + (_height / 2)) - nHeight / 2, nWidth, nHeight);
	}
	static drawEllipseH(x: number, y: number, w: number, h: number) {
		// console.log(w,h,w<h)
		// console.log("H")
		let h1: number = 0, w1: number = 0;
		if (!Global.panelClientRectDetailsForElipseError.height) {
			DrawRoofForPanel.getCurrentsize();
		}
		if (Global.panelClientRectDetailsForElipseError.height > Global.panelClientRectDetailsForElipseError.width) {
			h1 = 0.2 * Global.panelClientRectDetailsForElipseError.height / DrawRoofForPanel.currentScale;
			w1 = 0.75 * Global.panelClientRectDetailsForElipseError.width / DrawRoofForPanel.currentScale;
		} else {
			h1 = 0.25 * Global.panelClientRectDetailsForElipseError.height / DrawRoofForPanel.currentScale;
			w1 = 0.5 * Global.panelClientRectDetailsForElipseError.width / DrawRoofForPanel.currentScale;
		}
		const ellipse = new Konva.Ellipse({
			x: w > h ? x + w1 : x,
			y: y,
			radiusX: w1, //w * DrawRoofForPanel.currentScale,
			radiusY: h1,
			stroke: '#ff0000',
			strokeWidth: 5,
			name: "ellipseError"
		});
		// ellipse
		DrawRoofForPanel.elipseGroup.add(ellipse);
		DrawRoofForPanel.elipseGroup.moveToTop();
		ellipse.draw();
		// console.log(ellipse)
	}
	static drawEllipseV(x: number, y: number, w: number, h: number) {
		// console.log(w,h,w<h)
		// console.log("v")
		if (!Global.panelClientRectDetailsForElipseError.height) {
			DrawRoofForPanel.getCurrentsize();
		}
		let h1: number = 0, w1: number = 0;
		if (Global.panelClientRectDetailsForElipseError.height > Global.panelClientRectDetailsForElipseError.width) {
			h1 = 0.5 * Global.panelClientRectDetailsForElipseError.height / DrawRoofForPanel.currentScale;
			w1 = 0.25 * Global.panelClientRectDetailsForElipseError.width / DrawRoofForPanel.currentScale;
		} else {
			h1 = 0.75 * Global.panelClientRectDetailsForElipseError.height / DrawRoofForPanel.currentScale;
			w1 = 0.2 * Global.panelClientRectDetailsForElipseError.width / DrawRoofForPanel.currentScale;
		}
		const ellipse = new Konva.Ellipse({
			x: w > h ? x + w1 : x,
			y: y,
			radiusX: w1, //w * DrawRoofForPanel.currentScale,
			radiusY: h1,
			stroke: '#ff0000',
			strokeWidth: 5,
			name: "ellipseError"
		});
		// ellipse
		DrawRoofForPanel.elipseGroup.add(ellipse);
		DrawRoofForPanel.elipseGroup.moveToTop();
		ellipse.draw();
		// console.log(ellipse)
	}

	static drawEllipse1(x: number, y: number, w: number, h: number) {
		if (ModList.currentSelectedPanel) {
			Global.singlePanelSize = ModList.currentSelectedPanel.getClientRect();
		}
		const s = Global.singlePanelSize;
		// console.log("1")
		let d = {
			"x": s.x,
			"y": s.y,
			"width": s.width > s.height ? s.height : s.width,
			"height": s.width > s.height ? s.width : s.height,
		}
		let h1: number = 0, w1: number = 0;
		if (d.width) {
			h1 = 0.5 * d.height / DrawRoofForPanel.currentScale;
			w1 = d.width * 0.25 / DrawRoofForPanel.currentScale;
		} else {
			if (Global.panelClientRectDetailsForElipseError.height > Global.panelClientRectDetailsForElipseError.width) {
				h1 = 0.5 * Global.panelClientRectDetailsForElipseError.height / DrawRoofForPanel.currentScale;
				w1 = 0.25 * Global.panelClientRectDetailsForElipseError.width / DrawRoofForPanel.currentScale;
			} else {
				h1 = 0.75 * Global.panelClientRectDetailsForElipseError.height / DrawRoofForPanel.currentScale;
				w1 = 0.2 * Global.panelClientRectDetailsForElipseError.width / DrawRoofForPanel.currentScale;
			}
		}
		const ellipse = new Konva.Ellipse({
			x: x,// + w1 / 2,
			y: y - h1 / 3,
			radiusX: w1,
			radiusY: h1,
			stroke: '#ff0000',
			strokeWidth: 5,
			name: "ellipseError"
		});

		DrawRoofForPanel.elipseGroup.add(ellipse);
		DrawRoofForPanel.elipseGroup.moveToTop();
		if (ellipse.getWidth() / ellipse.getHeight() > 0.7) {
			ellipse.setWidth(ellipse.getWidth() * .6);
		}
		ellipse.draw();
		// console.log(ellipse)
	}
	static getGroups(): any[] {
		var groups: any[] = []
		var hGroups = [...Global.panelRows];
		hGroups = _.sortBy(hGroups, 'x');
		// console.log(hGroups);
		const g: any[] = [];
		const listOfIndexes: any = [];
		let panelWidth = (SC_Input.nModWidth / 10);
		let panelHeight = (SC_Input.nModHeight / 10);
		let w: number, h: number;
		hGroups.forEach((item, i) => {
			if (listOfIndexes.indexOf(i) == -1) {
				const a: any = [];
				a.push(item)
				hGroups.forEach((itemj, j) => {
					if (i != j) {
						if (item.panelCount == itemj.panelCount && item.x == itemj.x && item.portrait == itemj.portrait) {
							// itemj.portrait;
							if (itemj.portrait) {
								w = panelWidth
								h = panelHeight;
							} else {
								w = panelHeight;
								h = panelWidth;
							}
							const diff = (itemj.y - a[a.length - 1].y - h);
							a.push(itemj);
							listOfIndexes.push(j);
						}
					}
				});
				g.push(a);
			}
		})
		// 
		g.forEach((inner: any[]) => {
			let isInit = true;
			let b: any[] = []
			inner.forEach((t, ine: any) => {
				if (!isInit) {
					if (Math.abs(h + Sol50.nVertikalAbstand - (t.y - inner[ine - 1].y)) < Sol50.nVertikalAbstand) {
						b.push(t)
					} else {
						if (b.length > 0)
							groups.push(new GetArea(b));
						b = [];
						b.push(t);
						isInit = true;
					}
				} else {
					b.push(t);
					isInit = false;
				}
			});
			// console.log(b)
			groups.push(new GetArea(b));
		})
		return groups;
	}
}